import React, { Suspense, lazy, createElement } from 'react';
import { render } from 'react-dom';
// 🎨 Paint dark background INSTANTLY to prevent white flash
document.documentElement.style.backgroundColor = '#0a0a0a';
document.body.style.backgroundColor = '#0a0a0a';
document.body.style.margin = '0';
import './index.css';
// 🔥 Meta Pixel — fires IMMEDIATELY, before React even mounts
if (!(window as any).__pageview_fired) {
  ;
  (window as any).__pageview_fired = true;
  const n = ((window as any).fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  }) as any;
  if (!(window as any)._fbq) (window as any)._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
  (window as any).fbq('set', 'autoConfig', false, '1795951838046016');
  (window as any).fbq('init', '1795951838046016');
  (window as any).fbq('track', 'PageView', {
    content_type: 'product',
    content_category: 'Self Improvement',
    content_name: 'The Dream Decoding System™',
    content_ids: ['dream_decoding_system'],
    contents: [{
      id: 'dream_decoding_system',
      quantity: 1
    }],
    value: 19.99,
    currency: 'USD'
  });
  (window as any).fbq('track', 'ViewContent', {
    content_type: 'product',
    content_category: 'Self Improvement',
    content_name: 'The Dream Decoding System™',
    content_ids: ['dream_decoding_system'],
    contents: [{
      id: 'dream_decoding_system',
      quantity: 1
    }],
    value: 19.99,
    currency: 'USD'
  });
}
// Preconnect to critical domains immediately
const criticalDomains = [{
  href: 'https://connect.facebook.net',
  crossOrigin: 'anonymous'
}, {
  href: 'https://cdn.magicpatterns.com',
  crossOrigin: 'anonymous'
}, {
  href: 'https://www.paypal.com',
  crossOrigin: 'anonymous'
}];
criticalDomains.forEach(({
  href,
  crossOrigin
}) => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossOrigin) link.crossOrigin = crossOrigin;
  document.head.appendChild(link);
});
// Preload hero image (largest above-fold element)
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = 'https://cdn.magicpatterns.com/uploads/xe5QqmvYQYMzDYtLSnJ3RK/Diseno_sin_titulo_(27).webp';
document.head.appendChild(preloadImg);
import { App } from './App';
render(<App data-id="element-162" />, document.getElementById('root'));